import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

posthog.init(process.env.REACT_APP_POSTHOG_KEY || 'phc_feRlz4YYhB1xJ9IdQefBftK08f187uaTX5b9p65rNjx', {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com',
    person_profiles: 'identified_only',
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <PostHogProvider client={posthog}>
            <App />
        </PostHogProvider>
    </React.StrictMode>
);
